<!-- ══════════════════════════════════════════════════════════════════════════
     CONDICIONES COMERCIALES — el historial de versiones.

     🔴 REDISEÑO 2026-09-20 (contrato del rediseño). No hay botón de editar a
     propósito: las condiciones se versionan, no se pisan.

     Lo que decide quien abre esta pantalla: SI HAY QUE CREAR O APROBAR UNA
     VERSIÓN. Todo lo que no sirve a esa decisión bajó o se fue.

     Lo que salió, y por qué (medido antes de tocar nada):
       · TRES avisos apilados arriba —la doctrina, la versión sin comisión y la
         programada— más dos más adentro de la tarjeta. Cinco avisos en una
         pantalla no advierten nada. Quedó UNA cinta, que resuelve las
         condiciones en un solo estado; la doctrina bajó a un renglón al pie.
       · el aviso «esta versión rige pero nadie la aprobó» repetía la insignia
         que está tres centímetros más arriba y la cinta de la cabecera: el
         mismo dato tres veces.
       · las tres tarjetas — «Rige hoy», «Sin condición» e «Historial». Envolvían
         pares dato/valor y tablas, que no se tocan ni llevan a otro lado.
       · los subtítulos de sección, incluido el que repetía la vigencia y la
         autoría que ya están en los pares de abajo.
       · el bloque «Cargo fijo» suelto, que mostraba por segunda vez el valor
         que ya estaba en los pares.
     ══════════════════════════════════════════════════════════════════════════ -->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-21.
     Condiciones era la SÉPTIMA solapa de la ficha y se quedó afuera cuando las
     otras seis pasaron a rutas hijas: era hermana de `:code`, así que tocar su
     pestaña sacaba de la ficha y abría una pantalla entera —con su miga, su
     título y su «Volver al comercio»—, que es justo lo que Juan rechazó:
     *«en vez de pasarme por otro componente que después ni siquiera la atrás
     tiene»*, y nombró «condiciones» en esa misma lista.
     Lo que sí queda acá son las ACCIONES de esta pantalla. -->
<div class="space-y-8">

  <!-- El esqueleto conserva la FORMA: una cinta, un bloque de pares y una tabla. -->
  <div *ngIf="loading" class="space-y-8" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-9 w-1/3"></div>
    <div class="kb-skeleton h-14 w-full rounded-lg"></div>
    <div class="space-y-4">
      <div class="kb-skeleton h-3 w-28"></div>
      <div class="kb-skeleton h-5 w-full max-w-lg" *ngFor="let s of [1,2,3]"></div>
    </div>
  </div>

  <div class="kb-empty" *ngIf="!loading && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-file-contract" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
  </div>

  <ng-container *ngIf="!loading && !noEncontrado">

    <!-- 🔴 LAS ACCIONES, A LA DERECHA Y CON AIRE — el mismo molde que las otras
         seis hijas. «Volver al comercio» se fue: la barra de pestañas del padre
         está tres centímetros más arriba y ya no se salió de ningún lado. -->
    <div class="flex flex-wrap items-center justify-end gap-2 pt-2">
      <!-- 2026-09-24: sin versiones, el único botón es «Crear la primera versión» del aviso de abajo;
           éste repetía la misma acción. -->
      <button type="button" class="kb-btn kb-btn-primary" *ngIf="puede('terms.create') && versiones.length" (click)="nuevaVersion()">
        <i class="fas fa-plus" aria-hidden="true"></i>Nueva versión
      </button>
    </div>

    <!-- ══ Aviso y error de las acciones de esta pantalla — cero `Swal` ══════ -->
    <p class="text-sm font-medium kb-texto-exito" *ngIf="aviso" role="status">{{ aviso }}</p>
    <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
      <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
      <div><p class="m-0">{{ error }}</p></div>
    </div>

    <!-- ══ LA CINTA — una sola, y resuelve las tres condiciones en un estado ══
         El orden es el del daño: primero lo que impide facturarle. -->
    <div class="kb-cinta" *ngIf="estadoCondiciones === 'SIN_COMISION' && !esProveedor">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Hay una versión sin comisión definida.</strong>
        Mientras no tenga un monto, a este comercio no se le puede facturar. La versión inicial
        se crea sin comisión a propósito: el monto es una decisión de negocio.
      </p>
    </div>

    <div class="kb-cinta" *ngIf="estadoCondiciones === 'SIN_APROBAR'">
      <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">La versión que rige hoy no la aprobó nadie.</strong>
        Nace sin aprobar a propósito: quien carga los números no es necesariamente quien acepta
        el acuerdo. Se aprueba desde el historial, con el botón de su fila.
      </p>
    </div>

    <div class="kb-cinta kb-cinta-info" *ngIf="estadoCondiciones === 'PROGRAMADA'">
      <i class="fas fa-clock kb-cinta-icono" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Hay una versión programada: {{ futura.version.code }}.</strong>
        Empieza el {{ futura.version.date_init | date:'dd/MM/yyyy':'UTC' }} ({{ duracion(futura) }}) y
        ese día cierra la que rige hoy.
        <span *ngIf="!aprobada(futura)">Todavía no está aprobada.</span>
        Mientras no empiece, se puede cancelar.
      </p>
    </div>

    <!-- ══ Aprobada y por empezar (el aprobador del alta eligió una fecha futura) ══ -->
    <div class="kb-empty" *ngIf="estadoCondiciones === 'POR_EMPEZAR'">
      <span class="kb-empty-icono"><i class="fas fa-clock" aria-hidden="true"></i></span>
      <p class="kb-empty-titulo">Sus condiciones rigen desde el {{ futura.version.date_init | date:'dd/MM/yyyy':'UTC' }}</p>
      <p class="kb-empty-texto">
        {{ futura.version.code }} ya está aprobada. Desde ese día puede vender y se le factura.
      </p>
    </div>

    <!-- ══ Sin ninguna condición ══════════════════════════════════════════════
         Sin tarjeta alrededor: el vacío ya es su propio bloque. -->
    <!-- Proveedor de servicio: su tarifario se puede cargar, pero la liquidación automática no lo usa
         (Juan, 28-oct-2026: «Que no se tome en cuenta para que no se liquide»). -->
    <div class="kb-empty" *ngIf="estadoCondiciones === 'SIN_VIGENTE' && esProveedor">
      <span class="kb-empty-icono"><i class="fas fa-file-contract" aria-hidden="true"></i></span>
      <p class="kb-empty-titulo">Se le paga a mano mientras no tenga tarifario</p>
      <p class="kb-empty-texto">
        Puede cargar su tarifario (comisión, base y plazo). Queda guardado, pero
        <b>no se usa para liquidar</b>: a un proveedor de servicio se le sigue pagando a mano.
      </p>
      <button type="button" class="kb-btn kb-btn-primary mt-4" *ngIf="puede('terms.create')"
              (click)="nuevaVersion()">
        <i class="fas fa-plus" aria-hidden="true"></i>Cargar el tarifario
      </button>
    </div>
    <div class="kb-aviso kb-aviso-info mb-4" *ngIf="esProveedor && estadoCondiciones !== 'SIN_VIGENTE'">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      Tarifario cargado, todavía no se usa: a un proveedor de servicio se le paga a mano.
    </div>

    <div class="kb-empty" *ngIf="estadoCondiciones === 'SIN_VIGENTE' && !esProveedor">
      <span class="kb-empty-icono"><i class="fas fa-file-contract" aria-hidden="true"></i></span>
      <p class="kb-empty-titulo">Este comercio no tiene condición vigente</p>
      <p class="kb-empty-texto">
        Sin comisión vigente <b>no se le puede facturar</b>. Hay que crear la primera versión
        y aprobarla.
      </p>
      <button type="button" class="kb-btn kb-btn-primary mt-4" *ngIf="puede('terms.create')"
              (click)="nuevaVersion()">
        <i class="fas fa-plus" aria-hidden="true"></i>Crear la primera versión
      </button>
    </div>

    <div class="space-y-8">

      <!-- ══ La que rige hoy ══════════════════════════════════════════════════ -->
      <section class="kb-tarjeta" *ngIf="vigente">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Rige hoy</h2>
          <div class="kb-tarjeta-accion flex flex-wrap items-center gap-2">
          <span class="kb-badge kb-badge-marca shrink-0 font-mono">{{ vigente.version.code }}</span>
          <span class="kb-badge kb-badge-exito shrink-0" *ngIf="aprobada(vigente)">
            <i class="fas fa-check-circle" aria-hidden="true"></i>Aprobada
          </span>
          <span class="kb-badge kb-badge-alerta shrink-0" *ngIf="!aprobada(vigente)">
            <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>Sin aprobar
          </span>
          </div>
        </div>
        <div class="kb-tarjeta-cuerpo">

        <!-- 🔴 2026-09-24: la grilla de la ficha — rótulo gris arriba, valor en peso normal, la
             comisión grande—. Antes, rótulos en negrita a la izquierda. -->
        <dl class="m-0 grid gap-x-[24px] gap-y-[20px] sm:grid-cols-2 lg:grid-cols-3">
          <div class="sm:col-span-2 lg:col-span-3">
            <dt class="text-sm font-medium text-muted-foreground">Comisión</dt>
            <dd class="m-0 mt-1 flex flex-wrap items-baseline gap-x-2">
              <span class="text-2xl font-semibold tabular-nums">{{ comision(vigente) }}</span>
              <span class="text-sm text-muted-foreground">{{ base(vigente) }}<span *ngIf="plazoPorOmision(vigente)"> · a
                {{ etiquetaPlazo(plazoPorOmision(vigente)) }}</span></span>
            </dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Esquema de liquidación</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">
              <span *ngIf="modelo(vigente)">{{ modelo(vigente) }}</span>
              <span class="kb-dato-falta" *ngIf="!modelo(vigente)">
                <i class="fas fa-exclamation-circle mr-1.5" aria-hidden="true"></i>Sin definir: sin modelo no se liquida
              </span>
              <span class="kb-dato-nota mt-0.5 block" *ngIf="riesgo(vigente) !== '—'">riesgo: {{ riesgo(vigente) | lowercase }}</span>
            </dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Día no hábil</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">{{ diaHabil(vigente) }}</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Liquidación</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">{{ liquidacion(vigente) }}</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Contrato</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">
              <span *ngIf="vigente.contract_reference">{{ vigente.contract_reference }}</span>
              <span class="text-muted-foreground" *ngIf="!vigente.contract_reference">Sin referencia</span>
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="text-sm font-medium text-muted-foreground">Vigencia</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">
              <ng-container *ngIf="esLegacy(vigente); else desdeFecha">créditos vendidos hasta el {{ ultimaVenta(vigente) | date:'dd/MM/yyyy HH:mm':'-0400' }} · sin fecha de fin</ng-container>
              <ng-template #desdeFecha>desde {{ vigente.version.date_init | date:'dd/MM/yyyy':'UTC' }}</ng-template> · {{ vigente.version.name }}
              <span class="kb-dato-nota mt-0.5 block">{{ duracion(vigente) }} · {{ autoria(vigente) }}</span>
            </dd>
          </div>
        </dl>

        <!-- 📍 Una condición sin tarifario es del esquema viejo. Se dice pegado
             al dato, no en un aviso aparte: no es una alerta, es una aclaración. -->
        <p class="kb-hint" *ngIf="esEsquemaViejo(vigente)">
          Esta condición no tiene tarifario por plazo: usa una comisión única de
          <b>{{ comision(vigente) }}</b> {{ base(vigente) }} y una frecuencia
          <b>{{ FRECUENCIAS[vigente.settlement?.frequency] || '—' }}</b>. Al crear la próxima
          versión, el tarifario se precarga con ese mismo valor.
        </p>
        </div>
      </section>

      <!-- ══ El plazo de cobro ════════════════════════════════════════════════
           🔴 REGLA DE JUAN, 2026-09-28: una versión lleva UN plazo, no un
           tarifario con varias filas. Si la vigente es de antes de esta regla
           (varios plazos activos), se ve el marcado y se dice. -->
      <section class="kb-tarjeta" *ngIf="vigente && tarifario(vigente).length">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Plazo de cobro</h2>
        </div>
        <div class="kb-tarjeta-cuerpo">

        <div class="kb-aviso kb-aviso-info" *ngIf="variosPlazos(vigente)">
          <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
          <div>
            <p class="kb-aviso-titulo">Versión anterior a la regla de un plazo: rige el marcado</p>
            <p>Esta versión es de antes de «un plazo por versión» y tiene varios. El que se le
               aplica al comercio es el marcado con la estrella.</p>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="tplPlazos; context: { v: vigente }"></ng-container>
        <p class="kb-hint">
          Cada plazo tiene su comisión y define el período que se liquida.
          <b>La marcada se aplica si nadie elige otro.</b>
        </p>
        </div>
      </section>

      <!-- ══ Cargos al comercio (Mario, 27-oct): cada concepto, renglón por renglón. Reemplaza a «Otros
           conceptos de cobro»; el cargo por uso (con su interruptor de pausa) es el primer renglón. ═══ -->
      <section class="kb-tarjeta" *ngIf="vigente">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Cargos al comercio</h2>
        </div>
        <div class="kb-tarjeta-cuerpo">
          <ng-container *ngTemplateOutlet="tplCargos; context: { v: vigente, vivo: true }"></ng-container>
        </div>
      </section>

      <!-- ══ Cartera anterior (LCF-03, Mario 28-oct) ═════════════════════════
           MT-LEGACY rige por FECHA DE VENTA: pasada la firma sigue liquidando todo lo vendido antes. Solo
           lectura: cambiar sus condiciones (MT-LEGACY-2) es la etapa 2, después del 1-nov. -->
      <section class="kb-tarjeta" *ngIf="carteraAnterior as l">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Cartera anterior</h2>
          <div class="kb-tarjeta-accion flex flex-wrap items-center gap-2">
          <span class="kb-badge kb-badge-marca shrink-0 font-mono">{{ l.version.code }}</span>
          <span class="kb-badge kb-badge-exito shrink-0">
            <i class="fas fa-sync-alt" aria-hidden="true"></i>Sigue cobrando</span>
          </div>
        </div>
        <div class="kb-tarjeta-cuerpo">
        <p class="m-0 text-sm text-muted-foreground">
          Liquida las cuotas de los créditos vendidos hasta el corte ({{ ultimaVenta(l) | date:'dd/MM/yyyy HH:mm':'-0400' }}), mientras el cliente las pague. No tiene fecha de fin.
        </p>
        <dl class="mb-0 grid gap-x-[24px] gap-y-[20px] sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Qué cobra</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">Cuotas de créditos de antes del corte</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Desde cuándo</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">Ya rige · sin fecha de fin</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">¿Cuándo se le liquida?</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">{{ liquidacion(l) }}</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">Día no hábil</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">{{ diaHabil(l) }}</dd>
          </div>
          <div>
            <dt class="text-sm font-medium text-muted-foreground">En el acta y el Excel</dt>
            <dd class="m-0 mt-1 text-sm text-foreground">Marca «legacy · contra CxC»</dd>
          </div>
        </dl>
        <div>
          <h3 class="m-0 mb-2 text-sm font-semibold text-foreground">Plazo de cobro</h3>
          <ng-container *ngTemplateOutlet="tplPlazos; context: { v: l }"></ng-container>
        </div>
        <div>
          <h3 class="m-0 mb-2 text-sm font-semibold text-foreground">Cargos al comercio</h3>
          <ng-container *ngTemplateOutlet="tplCargos; context: { v: l, vivo: false }"></ng-container>
        </div>
        </div>
      </section>

      <!-- ══ Historial ════════════════════════════════════════════════════════ -->
      <section class="kb-tarjeta">
        <div class="kb-tarjeta-cab">
          <h2 class="text-base font-semibold leading-none">Historial de versiones</h2>
          <div class="kb-tarjeta-accion flex flex-wrap items-center gap-2">
          <span class="shrink-0 text-sm tabular-nums text-muted-foreground"
                *ngIf="versiones.length">{{ versiones.length }}</span>
          </div>
        </div>
        <div class="kb-tarjeta-cuerpo">

        <div class="kb-tabla-plana" *ngIf="versiones.length">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th">Versión</th>
                <th class="kb-th">Vigencia</th>
                <th class="kb-th">Comisión y cargo</th>
                <th class="kb-th">Esquema de liquidación</th>
                <th class="kb-th">Estado</th>
                <th class="kb-th kb-th-acciones"><span class="sr-only">Acciones</span></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let v of versiones">
              <!-- Mario, 27-oct: cada versión se puede presionar para ver su contrato completo. -->
              <tr class="kb-tr cursor-pointer hover:bg-muted/40" role="button" tabindex="0"
                  [attr.aria-expanded]="estaAbierta(v)" [attr.aria-controls]="'cc-detalle-' + v.version.code"
                  (click)="alternarDetalle(v)"
                  (keydown.enter)="teclaFila($event, v)"
                  (keydown.space)="teclaFila($event, v)"
                  [ngClass]="{'kb-tr-atenuada': vigencia(v) === 'CANCELADA', 'bg-muted/40': confirmando?.code === v.version.code || estaAbierta(v)}">
                <td class="kb-td">
                  <div class="flex items-start gap-2">
                    <i class="fas mt-1 w-3 shrink-0 text-xs text-muted-foreground" aria-hidden="true"
                       [ngClass]="estaAbierta(v) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                    <div class="min-w-0">
                      <span class="kb-td-titulo font-mono">{{ v.version.code }}</span>
                      <p class="kb-td-sub">{{ v.version.name }}</p>
                    </div>
                  </div>
                </td>
                <!-- Una sola línea por dato (Juan, 08-oct): la vigencia como rango y debajo cuánto duró. -->
                <td class="kb-td tabular-nums whitespace-nowrap">
                  <ng-container *ngIf="esLegacy(v); else rango">
                    <span class="block">sin fin · créditos hasta {{ ultimaVenta(v) | date:'dd/MM':'-0400' }}</span>
                    <span class="kb-td-sub block">{{ duracion(v) }}</span>
                  </ng-container>
                  <ng-template #rango>
                  <span class="block" *ngIf="finDe(v)">
                    {{ v.version.date_init | date:'dd/MM':'UTC' }} → {{ finDe(v) | date:'dd/MM/yyyy':'UTC' }}
                  </span>
                  <span class="block" *ngIf="!finDe(v)">desde {{ v.version.date_init | date:'dd/MM/yyyy':'UTC' }}</span>
                  <span class="kb-td-sub block">{{ vigencia(v) === 'CANCELADA' ? 'nunca rigió' : duracion(v) }}</span>
                  </ng-template>
                </td>
                <td class="kb-td tabular-nums whitespace-nowrap">
                  <span class="block">{{ comisionYPlazo(v) }}</span>
                  <span class="kb-td-sub block">{{ base(v) }}</span>
                  <span class="kb-td-sub block" *ngIf="cargoFijo(v)">cargo {{ cargoFijo(v) }}</span>
                  <span class="kb-td-sub block" *ngIf="v.charges?.length">+ {{ v.charges.length }} concepto(s)</span>
                </td>
                <td class="kb-td">{{ modeloNegocio(v) }}
                  <span class="kb-td-sub block" *ngIf="momentoCorto(v)">{{ momentoCorto(v) }}</span></td>
                <td class="kb-td">
                  <div class="flex flex-wrap items-center gap-1">
                    <span class="kb-badge kb-badge-exito" *ngIf="vigencia(v) === 'VIGENTE'">
                      <i class="fas fa-check-circle" aria-hidden="true"></i>Vigente
                    </span>
                    <span class="kb-badge kb-badge-marca" *ngIf="vigencia(v) === 'FUTURA'">
                      <i class="fas fa-clock" aria-hidden="true"></i>Futura
                    </span>
                    <span class="kb-badge kb-badge-neutro" *ngIf="vigencia(v) === 'CERRADA'">Cerrada</span>
                    <!-- LCF-05/06 (Mario, 28-oct): ni la legacy está cerrada ni lo que el 74 reemplazó está cancelado. -->
                    <span class="kb-badge kb-badge-marca" *ngIf="vigencia(v) === 'CARTERA'">
                      <i class="fas fa-history" aria-hidden="true"></i>Cartera anterior
                    </span>
                    <span class="kb-badge kb-badge-neutro !whitespace-normal" *ngIf="vigencia(v) === 'REEMPLAZADA'">Reemplazada por MT-LEGACY</span>
                    <!-- 🔴 Certificación 2026-09-28: sin esta insignia una versión cancelada en el núcleo
                         (`state: 'INACTIVE'`) seguía leyendo «Futura · Sin aprobar» con sus botones. -->
                    <span class="kb-badge kb-badge-neutro" *ngIf="vigencia(v) === 'CANCELADA'">Cancelada</span>
                    <span class="kb-badge kb-badge-contorno" *ngIf="aprobada(v) && !['CANCELADA', 'REEMPLAZADA'].includes(vigencia(v)) && vigencia(v) !== 'VIGENTE'">Aprobada</span>
                    <span class="kb-badge kb-badge-alerta" *ngIf="!aprobada(v) && !['CANCELADA', 'REEMPLAZADA'].includes(vigencia(v))">Sin aprobar</span>
                  </div>
                </td>
                <td class="kb-td-acciones" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                  <div class="kb-acciones-grupo" *ngIf="!confirmandoEsta(v, 'aprobar') && !confirmandoEsta(v, 'cancelar')">
                    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm"
                            *ngIf="puede('terms.approve') && !aprobada(v) && !['CANCELADA', 'REEMPLAZADA'].includes(vigencia(v))"
                            (click)="pedirAprobar(v)">Aprobar</button>
                    <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm text-destructive"
                            *ngIf="puede('terms.approve') && cancelable(v)" (click)="pedirCancelar(v)">Cancelar la versión</button>
                  </div>
                </td>
              </tr>
              <!-- Detalle completo de la versión (una abierta a la vez). -->
              <tr *ngIf="estaAbierta(v)" class="kb-tr bg-muted/40" [id]="'cc-detalle-' + v.version.code">
                <td class="kb-td" colspan="6">
                  <!-- en el teléfono la tabla se desplaza de lado: el detalle se queda fijo y del ancho de la pantalla -->
                  <div class="sticky left-0 grid grid-cols-1 max-w-[calc(100vw-5.5rem)] gap-x-8 gap-y-6 whitespace-normal md:max-w-none md:grid-cols-2">
                    <div>
                      <h3 class="m-0 text-sm font-semibold">Comisión y riesgo</h3>
                      <dl class="m-0 mt-2 grid gap-y-2">
                        <div><dt class="kb-dato-nota">Comisión</dt>
                          <dd class="m-0 text-sm tabular-nums">{{ comisionYPlazo(v) }} <span class="text-muted-foreground">{{ base(v) }}</span></dd></div>
                        <div><dt class="kb-dato-nota">Esquema</dt><dd class="m-0 text-sm">{{ modeloNegocio(v) }}</dd></div>
                        <div><dt class="kb-dato-nota">Riesgo</dt><dd class="m-0 text-sm">{{ riesgo(v) }}</dd></div>
                      </dl>
                    </div>
                    <div>
                      <h3 class="m-0 text-sm font-semibold">Liquidación</h3>
                      <dl class="m-0 mt-2 grid gap-y-2">
                        <div *ngIf="frecuencia(v)"><dt class="kb-dato-nota">Frecuencia</dt><dd class="m-0 text-sm">{{ frecuencia(v) }}</dd></div>
                        <div><dt class="kb-dato-nota">Momento</dt><dd class="m-0 text-sm">{{ momentoLiquidacion(v) }}</dd></div>
                        <div><dt class="kb-dato-nota">Días de pago</dt><dd class="m-0 text-sm">{{ diasDePago(v) }}</dd></div>
                        <div><dt class="kb-dato-nota">Día no hábil</dt><dd class="m-0 text-sm">{{ diaHabil(v) }}</dd></div>
                      </dl>
                    </div>
                    <div class="md:col-span-2" *ngIf="tarifario(v).length">
                      <h3 class="m-0 text-sm font-semibold">Tarifario</h3>
                      <div class="kb-tabla-plana mt-2">
                        <table class="kb-table">
                          <thead class="kb-thead">
                            <tr>
                              <th class="kb-th">Plazo</th>
                              <th class="kb-th kb-th-num">Comisión</th>
                              <th class="kb-th kb-th-num">Descuento</th>
                              <th class="kb-th">Base</th>
                              <th class="kb-th">Por omisión</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="kb-tr last:border-b-0" *ngFor="let r of tarifario(v)" [ngClass]="{'kb-tr-elegida': r.is_default}">
                              <td class="kb-td">{{ etiquetaPlazo(r) }}</td>
                              <td class="kb-td kb-td-num tabular-nums">{{ r.commission_value }}{{ (r.type_calc || v.commission?.type_calc) === 'PERCENTAGE' ? ' %' : '' }}</td>
                              <td class="kb-td kb-td-num tabular-nums">{{ porcentaje(r.discount_value) }}</td>
                              <td class="kb-td kb-td-sub">{{ (r.type_calc || v.commission?.type_calc) === 'FIXED' ? 'no depende de la venta' : baseDePlazo(r, v) }}</td>
                              <td class="kb-td"><span class="kb-badge kb-badge-marca" *ngIf="r.is_default"><i class="fas fa-star" aria-hidden="true"></i>Sí</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="md:col-span-2">
                      <h3 class="m-0 text-sm font-semibold">Cargos al comercio</h3>
                      <div class="mt-2">
                        <ng-container *ngTemplateOutlet="tplCargos; context: { v: v, vivo: false }"></ng-container>
                      </div>
                    </div>
                    <div class="md:col-span-2">
                      <h3 class="m-0 text-sm font-semibold">Autoría</h3>
                      <dl class="m-0 mt-2 grid gap-x-8 gap-y-2 sm:grid-cols-2 lg:grid-cols-4">
                        <div><dt class="kb-dato-nota">Creada</dt>
                          <dd class="m-0 text-sm tabular-nums">{{ fecha(v.created_by?.date) }}<span *ngIf="quien(v.created_by?.user)"> · {{ quien(v.created_by?.user) }}</span></dd></div>
                        <div><dt class="kb-dato-nota">Aprobada</dt>
                          <dd class="m-0 text-sm tabular-nums">
                            <ng-container *ngIf="aprobada(v)">{{ fecha(v.approved_by?.date) }}<span *ngIf="quien(v.approved_by?.user)"> · {{ quien(v.approved_by?.user) }}</span></ng-container>
                            <ng-container *ngIf="!aprobada(v)">sin aprobar</ng-container>
                          </dd></div>
                        <div><dt class="kb-dato-nota">Referencia del contrato</dt><dd class="m-0 text-sm">{{ v.contract_reference || '—' }}</dd></div>
                        <div *ngIf="v.updated_by?.date"><dt class="kb-dato-nota">Última modificación</dt>
                          <dd class="m-0 text-sm tabular-nums">{{ fecha(v.updated_by.date) }}</dd></div>
                      </dl>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- Cero `Swal`, y ya no apretada en la celda de acciones (Juan, 08-oct): la confirmación
                   se abre en una franja a todo el ancho, debajo de la versión, y dice qué cubre. -->
              <tr *ngIf="confirmandoEsta(v, 'aprobar') || confirmandoEsta(v, 'cancelar')" class="kb-tr bg-muted/40">
                <td class="kb-td" colspan="6">
                  <div class="flex flex-wrap items-center gap-x-6 gap-y-3">
                    <div class="min-w-0 flex-1">
                      <ng-container *ngIf="confirmandoEsta(v, 'aprobar')">
                        <p class="m-0 text-sm text-foreground">
                          <span class="font-semibold">¿Aprobar {{ v.version.code }}?</span>
                          <ng-container *ngIf="vigencia(v) === 'CERRADA'"> Ya está cerrada: se usa para liquidar las ventas de esos días.</ng-container>
                          <ng-container *ngIf="vigencia(v) !== 'CERRADA'"> Desde su fecha de inicio, es lo que se le factura.</ng-container>
                        </p>
                        <p class="m-0 mt-1 flex flex-wrap gap-x-6 text-xs text-muted-foreground tabular-nums" *ngIf="vigencia(v) === 'CERRADA'">
                          <span>Cubre <span class="text-foreground">{{ v.version.date_init | date:'dd/MM/yyyy':'UTC' }} → {{ v.version.date_end | date:'dd/MM/yyyy':'UTC' }}</span></span>
                          <span><span class="text-foreground">{{ diasCubiertos(v) }} días</span> de ventas</span>
                          <span>Comisión <span class="text-foreground">{{ comision(v) }}</span><ng-container *ngIf="cargoFijo(v)"> · cargo <span class="text-foreground">{{ cargoFijo(v) }}</span></ng-container></span>
                        </p>
                      </ng-container>
                      <p class="m-0 text-sm text-foreground" *ngIf="confirmandoEsta(v, 'cancelar')">
                        <span class="font-semibold">¿Cancelar {{ v.version.code }}?</span> Se descarta y vuelve a regir la anterior.
                      </p>
                    </div>
                    <div class="kb-acciones-grupo">
                      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="accionando"
                              (click)="descartarConfirmacion()">{{ confirmandoEsta(v, 'cancelar') ? 'Dejarla como está' : 'Cancelar' }}</button>
                      <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" [disabled]="accionando"
                              *ngIf="confirmandoEsta(v, 'aprobar')" (click)="aprobar(v)">
                        <i class="fas" [ngClass]="accionando ? 'fa-spinner fa-spin' : 'fa-check'" aria-hidden="true"></i>Aprobar {{ v.version.code }}
                      </button>
                      <button type="button" class="kb-btn kb-btn-danger kb-btn-sm" [disabled]="accionando"
                              *ngIf="confirmandoEsta(v, 'cancelar')" (click)="cancelar(v)">
                        <i class="fas" [ngClass]="accionando ? 'fa-spinner fa-spin' : 'fa-times'" aria-hidden="true"></i>Sí, cancelar
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div class="kb-empty" *ngIf="!versiones.length">
          <span class="kb-empty-icono"><i class="fas fa-history" aria-hidden="true"></i></span>
          <p class="kb-empty-titulo">Todavía no hay ninguna versión</p>
          <p class="kb-empty-texto" *ngIf="!esProveedor">La primera versión es la que habilita facturarle.</p>
          <p class="kb-empty-texto" *ngIf="esProveedor">El tarifario queda guardado como referencia: a un proveedor se le paga a mano.</p>
        </div>
        </div>
      </section>

    </div>

    <!-- ══ El pie: por qué esto se versiona ═══════════════════════════════════
         Reemplaza al aviso azul que abría la pantalla. Es doctrina, no una
         alerta: no compite con la cinta. -->
    <p class="border-t border-border pt-5 text-sm text-muted-foreground">
      Las condiciones no se editan: se versionan. Una comisión que ya rigió no se puede cambiar
      hacia atrás —hay liquidaciones emitidas con ella—, así que para cambiarla se crea una
      versión nueva con su fecha de inicio y la anterior queda cerrada como historia. De la más
      nueva a la más vieja: lo cerrado no se toca.
    </p>

  </ng-container>
</div>

<!-- Los renglones de cargos, UNO solo para «Rige hoy» (vivo: con el interruptor del cargo por uso) y para el
     detalle de cada versión (sin interruptores). Los arma cargosDeComercio. Mario, 27-oct. -->
<ng-template #tplCargos let-v="v" let-vivo="vivo">
  <ul class="m-0 list-none divide-y divide-border p-0" *ngIf="cargos(v).length">
    <li class="grid gap-x-6 gap-y-1 py-3 first:pt-0 last:pb-0 sm:grid-cols-5 sm:items-start" *ngFor="let c of cargos(v)"
        [class.opacity-70]="c.pausado">
      <div class="min-w-0">
        <span class="text-sm font-medium text-foreground">{{ c.concepto }}</span>
        <p class="kb-dato-nota m-0" *ngIf="c.descripcion">{{ c.descripcion }}</p>
      </div>
      <div class="text-sm font-semibold tabular-nums text-foreground" [class.line-through]="c.pausado">{{ c.monto }}</div>
      <div class="text-sm">
        <span class="kb-dato-nota block">Base</span>
        <span class="text-foreground">{{ c.base }}</span>
      </div>
      <div class="text-sm">
        <span class="kb-dato-nota block">Cuándo</span>
        <span class="text-foreground">{{ c.cuando }}</span>
      </div>
      <div>
        <span class="kb-badge" [ngClass]="c.pausado ? 'kb-badge-neutro' : 'kb-badge-exito'">{{ c.estado }}</span>
      </div>
      <!-- 🔴 TEMPORAL, PARA PRUEBAS (Juan, 2026-09-25): apagar el cargo por uso para probar el débito inmediato
           sin el dólar. Sólo el que se cobra con la inicial: es el que la caja le cobra al cliente. -->
      <div class="sm:col-span-5" *ngIf="vivo && c.clave === 'flat_fee' && v.flat_fee?.charged_with === 'INITIAL' && puede('update')">
        <div class="mt-1 flex items-center gap-2">
          <button type="button" role="switch" class="cc-switch" id="cc-cobrar-cargo"
                  [attr.aria-checked]="!cargoEnPausa" [class.cc-switch-on]="!cargoEnPausa"
                  [attr.aria-busy]="guardandoCargo || null" [disabled]="guardandoCargo"
                  (click)="cambiarCargo(cargoEnPausa)">
            <span class="cc-switch-bolita" aria-hidden="true"></span>
          </button>
          <label for="cc-cobrar-cargo" class="m-0 cursor-pointer text-sm text-foreground">
            {{ cargoEnPausa ? 'No se cobra' : 'Se cobra' }}
          </label>
          <span class="kb-badge kb-badge-alerta shrink-0" *ngIf="cargoEnPausa">
            <i class="fas fa-pause-circle" aria-hidden="true"></i>En pausa
          </span>
        </div>
        <p class="kb-error" *ngIf="errorCargo">{{ errorCargo }}</p>
        <span class="kb-dato-nota mt-1 block">
          {{ cargoEnPausa
            ? 'Temporal, para pruebas: ni las ventas nuevas ni las que esperan cobro llevan cargo.'
            : 'Se puede apagar un rato para probar; lo ya cobrado no cambia.' }}
        </span>
      </div>
    </li>
  </ul>
  <p class="m-0 text-sm text-muted-foreground" *ngIf="!cargos(v).length">
    Esta versión no le cobra ningún cargo al comercio, solo la comisión.
  </p>
</ng-template>

<!-- LCF-04 (Mario, 28-oct): el tarifario, UNO solo para «Rige hoy» y para la cartera anterior: mismas columnas
     que una versión normal. 0 % es un valor más. -->
<ng-template #tplPlazos let-v="v">
  <div class="kb-tabla-plana">
    <table class="kb-table">
      <thead class="kb-thead">
        <tr>
          <th class="kb-th">Plazo de cobro</th>
          <th class="kb-th kb-th-num">Comisión</th>
          <th class="kb-th kb-th-num">Descuento</th>
          <th class="kb-th">Base de cálculo</th>
          <th class="kb-th">Por omisión</th>
        </tr>
      </thead>
      <tbody>
        <tr class="kb-tr last:border-b-0" *ngFor="let r of tarifario(v)"
            [ngClass]="{'kb-tr-elegida': r.is_default}">
          <td class="kb-td">
            <span class="kb-td-titulo">{{ etiquetaPlazo(r) }}</span>
            <p class="kb-td-sub tabular-nums">liquida el período de {{ r.days }} {{ r.days === 1 ? 'día' : 'días' }}</p>
            <p class="kb-td-sub" *ngIf="r.notes">{{ r.notes }}</p>
          </td>
          <td class="kb-td kb-td-num" [ngClass]="{'font-semibold': r.is_default}">
            {{ r.commission_value }}{{ (r.type_calc || v.commission?.type_calc) === 'PERCENTAGE' ? ' %' : '' }}
          </td>
          <td class="kb-td kb-td-num">{{ r.discount_value || 0 }} %</td>
          <td class="kb-td kb-td-sub">
            {{ (r.type_calc || v.commission?.type_calc) === 'FIXED'
               ? 'no depende de la venta' : baseDePlazo(r, v) }}
          </td>
          <td class="kb-td">
            <span class="kb-badge kb-badge-marca" *ngIf="r.is_default">
              <i class="fas fa-star" aria-hidden="true"></i>Sí
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
